import { Component, Input, OnInit } from "@angular/core";
import { OtDTO } from "app/main/apps/shared/interfaces/ot.interface";
import { OrdenesDeTrabajoService } from "app/main/apps/shared/services/rest/ordenes-de-trabajo.service";
import { ArchivoService } from "app/main/apps/shared/services/util/acrhivo.service";
import { config } from "app/app.config";
@Component({
    selector: "app-ordenes-trabajo-oocc",
    templateUrl: "./ordenes-trabajo-oocc.component.html",
    styleUrls: ["./ordenes-trabajo-oocc.component.scss"],
})
export class OrdenesTrabajoOoccComponent implements OnInit {
    @Input() ordenesTrabajo: OtDTO[];
    config;
    constructor(
        private _archivoSrvc: ArchivoService,
        private _otSrvc: OrdenesDeTrabajoService
    ) {
        this.config = config;
    }

    ngOnInit(): void {}

    bajarPdf(idOT: number) {
        this._otSrvc.bajarPdf(idOT).subscribe((resp) => {
            this._archivoSrvc.descargar(resp, `OrdenTrabajo_${idOT}.pdf`);
        });
    }
}
